const { SVG_TAGS } = require('../constants');
const {
    STOP_COLOR_RGX,
    GRADIENTS_ATTRIBUTES,
    STOP_COLOR_ATTRIBUTES
} = require('./constants');

const gradientIsLinked = ({ attributes }) => attributes.getNamedItem(GRADIENTS_ATTRIBUTES.XLINK_HREF);

const getStopOffset = ({ attributes }) => {
    const offsetAttr = attributes.getNamedItem(STOP_COLOR_ATTRIBUTES.OFFSET);
    if (offsetAttr) {
        const offset = offsetAttr.value;
        return offset.includes('%')
            ? parseFloat(offset) / 100
            : parseFloat(offset);
    }
};

const getStopColor = ({ attributes }) => {
    const stopColorAttr = attributes.getNamedItem(STOP_COLOR_ATTRIBUTES.STOP_COLOR);
    if (stopColorAttr) {
        return stopColorAttr.value;
    } else {
        const styleAttr = attributes.getNamedItem(STOP_COLOR_ATTRIBUTES.STYLE);
        if (styleAttr) {

            const regexpResult = STOP_COLOR_RGX.exec(styleAttr.value);
            if (regexpResult) {
                return regexpResult[1];
            }
        }
    }
};

const parseStopColor = (stopElement) => {
    const offset = getStopOffset(stopElement);
    const color = getStopColor(stopElement);

    if (offset !== undefined && color !== undefined) {
        return { offset, color };
    }
};

const parseGradient = (gradientElement) =>
    ([...gradientElement.children]).reduce((result, stopElement) => {
        const parsedStopColor = parseStopColor(stopElement);
        if (parsedStopColor) {
            result.push(parsedStopColor);
        }
        return result;
    }, []);

/**
 * Gets and parses all the gradients from svg element
 * @param {SVGElement} svgElement
 * @returns {Object}
 */
const getGradientsMap = (svgElement) => ([
    ...svgElement.getElementsByTagName(SVG_TAGS.LINEAR_GRADIENT),
    ...svgElement.getElementsByTagName(SVG_TAGS.RADIAL_GRADIENT)
]).reduce((result, gradientElement) => {
    if (!gradientIsLinked(gradientElement)) {
        const parsedGradient = parseGradient(gradientElement);
        if (parsedGradient.length) {
            result[gradientElement.id] = parsedGradient;
        }
    }
    return result;
}, {});

module.exports = getGradientsMap;
